import React, {useState} from 'react';
import BoardsCtx from "./boardsCtx";

import AnalysisContentObjectModel from '../../models/AnalysisContentObjectModel';
import { IBoardObject } from '../../core/boards/types/IBoardObject';
import { ICurrency } from '../../core/boards/types/ICurrency';
import { ITimePeriod } from '../../core/boards/types/ITimePeriod';

export interface IBoardFiltersValue {
  boardId: number,
  investorId: number,
  selectedObject: IBoardObject | null,
  selectedCurrency: ICurrency | null,
  selectedPeriod: ITimePeriod | null,
}

const BoardsContext = (props) => {
  const [boardFiltersValues, setBoardFiltersValues] = useState<IBoardFiltersValue[]>([]);

  return (
    <BoardsCtx.Provider value={{
      boardFiltersValues: boardFiltersValues,
      setBoardFiltersValues: setBoardFiltersValues
    }}>{props.children}</BoardsCtx.Provider>
  )
}

export default BoardsContext;